var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "my-gallery",
    attrs: {
      "itemscope": "",
      "itemtype": "http://schema.org/ImageGallery"
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('figure', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: index === 0 || !_vm.singleThumbnail,
        expression: "index === 0 || !singleThumbnail"
      }],
      key: index,
      staticClass: "gallery-thumbnail",
      attrs: {
        "itemprop": "associatedMedia",
        "itemscope": "",
        "itemtype": "http://schema.org/ImageObject",
        "src": item.src
      }
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.nbThumbnailsDisplayed === -1 || index < _vm.nbThumbnailsDisplayed,
        expression: "nbThumbnailsDisplayed === -1 || index < nbThumbnailsDisplayed"
      }],
      attrs: {
        "href": item.src,
        "itemprop": "contentUrl",
        "data-size": '' + item.w + 'x' + item.h,
        "title": item.title
      }
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": item.alt,
        "itemprop": "thumbnail"
      }
    })])]);
  }), 0), _c('div', {
    staticClass: "pswp",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pswp__bg"
  }), _c('div', {
    staticClass: "pswp__scroll-wrap"
  }, [_vm._m(0), _c('div', {
    staticClass: "pswp__ui pswp__ui--hidden"
  }, [_c('div', {
    staticClass: "pswp__top-bar"
  }, [_c('div', {
    staticClass: "pswp__counter"
  }), _c('button', {
    staticClass: "pswp__button pswp__button--close",
    attrs: {
      "title": "Close (Esc)"
    }
  }), _vm.options.rotationOn ? _c('button', {
    staticClass: "pswp__button pswp__button--rotate pswp__button--rotate--left",
    attrs: {
      "title": "Rotate left"
    },
    on: {
      "click": function click($event) {
        return _vm.rotate(-90);
      }
    }
  }) : _vm._e(), _vm.options.rotationOn ? _c('button', {
    staticClass: "pswp__button pswp__button--rotate pswp__button--rotate--right",
    attrs: {
      "title": "Rotate right"
    },
    on: {
      "click": function click($event) {
        return _vm.rotate(90);
      }
    }
  }) : _vm._e(), _c('button', {
    staticClass: "pswp__button pswp__button--share",
    attrs: {
      "title": "Share"
    }
  }), _c('button', {
    staticClass: "pswp__button pswp__button--fs",
    attrs: {
      "title": "Toggle fullscreen"
    }
  }), _c('button', {
    staticClass: "pswp__button pswp__button--zoom",
    attrs: {
      "title": "Zoom in/out"
    }
  }), _vm._m(1)]), _vm._m(2), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--left",
    attrs: {
      "title": "Previous (arrow left)"
    },
    on: {
      "click": _vm.resetAngle
    }
  }), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--right",
    attrs: {
      "title": "Next (arrow right)"
    },
    on: {
      "click": _vm.resetAngle
    }
  }), _vm._m(3)])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pswp__container"
  }, [_c('div', {
    staticClass: "pswp__item"
  }), _c('div', {
    staticClass: "pswp__item"
  }), _c('div', {
    staticClass: "pswp__item"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pswp__preloader"
  }, [_c('div', {
    staticClass: "pswp__preloader__icn"
  }, [_c('div', {
    staticClass: "pswp__preloader__cut"
  }, [_c('div', {
    staticClass: "pswp__preloader__donut"
  })])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
  }, [_c('div', {
    staticClass: "pswp__share-tooltip"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pswp__caption"
  }, [_c('div', {
    staticClass: "pswp__caption__center"
  })]);
}]

export { render, staticRenderFns }